import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { h4, paragraphRegular } from '@helpers/typography';
import ArticleTagsStyles from '@stories/Components/Misc/ArticleTags/ArticleTags.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
import { gridColumns } from '../RichText/RichText.styles';
const Container = styled(SectionWrapper) `
  --baseThemeColour: ${brand.green.default};

  &[data-type='savings'] {
    --baseThemeColour: ${brand.blue.default};
  }

  &[data-type='intermediaries'] {
    --baseThemeColour: ${brand.blue.navy};
  }

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
  }
`;
const IntroBlock = styled.div `
  ${gridColumns};

  padding-left: 14px;
  margin-bottom: ${fluid(18, 29)};

  ${ArticleTagsStyles.Container} {
    margin-bottom: 18px;
    column-gap: ${fluid(7, 7)};

    @media ${from(Device.TabletLarge)} {
      margin-bottom: 16px;
    }
  }

  ${ArticleTagsStyles.Tag} {
    font-size: ${fluid(12, 16)};
    line-height: ${fluid(20, 26)};
    padding-top: ${fluid(5, 8)};
    padding-bottom: ${fluid(5, 8)};
  }

  @media ${from(Device.TabletLarge)} {
    padding-left: 30px;
  }
`;
const TitleBlock = styled.div `
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 5px;
    left: -14px;
    width: ${fluid(4, 7)};
    height: calc(100% - 5px);
    background: var(--baseThemeColour, ${brand.green.default});

    @media ${from(Device.TabletLarge)} {
      left: -30px;
    }
  }
`;
const Title = styled.h1 `
  ${h4};

  font-size: ${fluid(28, 38)};
  margin-bottom: ${fluid(12, 16)};
`;
const Introduction = styled.p `
  ${paragraphRegular};
  ${fonts.proximaNova.semiBold};

  margin-bottom: ${fluid(14, 14)};
`;
const AuthorBlock = styled.div `
  margin-top: ${fluid(18, 28)};
  display: flex;
  align-items: center;
  gap: 16px;
`;
const AuthorImageHolder = styled.div `
  width: 52px;
  height: 52px;
  overflow: hidden;
  border: 1px solid var(--baseThemeColour);
  border-radius: 50%;
`;
const AuthorImage = styled.img `
  width: 100%;
  height: 100%;
  object-fit: cover;
  color: ${brand.global.black};
`;
const AuthorName = styled.span `
  ${fonts.proximaNova.semiBold};
  font-size: ${fluid(16, 16)};
`;
const MediaHolder = styled.div `
  ${gridColumns};
  ${imageWrapperPreserveRatio(855, 638)};

  overflow: hidden;
  border-radius: 20px 20px 20px 0;
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const NewsArticleHeaderStyles = {
    AuthorBlock,
    AuthorImage,
    AuthorImageHolder,
    AuthorName,
    Container,
    Image,
    IntroBlock,
    Introduction,
    MediaHolder,
    Title,
    TitleBlock,
};
export default NewsArticleHeaderStyles;
